export default __webpack_public_path__ + "static/media/snails.9b7a5ca5.svg";